import { SafeImage } from '@/components/common/safe-image';
import useConversationStore, { useConversationHandlers } from '@/hooks/conversations/use-conversation-store';
import usePreloadImage from '@/hooks/use-preload-image';
import cn from '@/utils/merge-class-names';
import type { ContentCommonProps } from './content-common-props';
import { MessageQuote } from './message-quote';

export default function ContentImage({ message }: ContentCommonProps) {
  const { src: safeSrc, aspectRatio, dimension } = usePreloadImage(message.Message);
  const { resetSelectedMessages } = useConversationStore();
  const { handleInteraction: onInteraction } = useConversationHandlers();

  const handleViewImage = () => {
    resetSelectedMessages([message]);
    onInteraction('preview');
  };

  return (
    <div
      className={cn('w-fit flex flex-col max-w-90vw desktop:max-w-50vw', {
        'chat-bubble group-data-receiver:chat-bubble-plain group-data-sender:chat-bubble-primary group-data-sender:items-end':
          Boolean(message.Quote),
      })}>
      {message.Quote && (
        <MessageQuote
          className='mb-1 w-full'
          quote={message.Quote}
        />
      )}

      <div className='relative'>
        <span className='loading text-primary loading-spinner absolute -z-10 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2' />

        <SafeImage
          src={safeSrc}
          displaySize='fixed'
          style={{
            aspectRatio: aspectRatio ?? 'auto',
            width: dimension[0] ?? '100%',
          }}
          className='rounded-md min-w-16 bg-cover desktop:max-w-30vw desktop:h-full'
        />

        <button
          type='button'
          className='absolute inset-0 z-10 flex cursor-pointer items-end justify-end rounded-lg data-quote:hidden'
          onClick={handleViewImage}
        />
      </div>
    </div>
  );
}
